export default __webpack_public_path__ + "static/media/download-app-bg.15588ca5.png";